/**
 * Soft-fade product hero carousel. No bounce.
 */
(function () {
  var root = document.querySelector('[data-lc-hero-carousel]');
  if (!root) return;

  // Enable slide transitions only after first paint so the LCP slide
  // does not fade in when CSS arrives.
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      root.classList.add('lc-hero--ready');
    });
  });

  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lc-hero-slide]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lc-hero-dot]'));
  if (slides.length < 2) return;

  var index = 0;
  var timer = null;
  var autoplay = parseInt(root.getAttribute('data-autoplay') || '5500', 10);
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function goTo(next) {
    if (next === index) return;
    slides[index].classList.remove('is-active');
    slides[index].setAttribute('aria-hidden', 'true');
    if (dots[index]) {
      dots[index].classList.remove('is-active');
      dots[index].removeAttribute('aria-current');
    }

    index = (next + slides.length) % slides.length;

    slides[index].classList.add('is-active');
    slides[index].removeAttribute('aria-hidden');
    if (dots[index]) {
      dots[index].classList.add('is-active');
      dots[index].setAttribute('aria-current', 'true');
    }
  }

  function next() {
    goTo(index + 1);
  }

  function prev() {
    goTo(index - 1);
  }

  function start() {
    if (reduceMotion || autoplay < 1000) return;
    stop();
    timer = window.setInterval(next, autoplay);
  }

  function stop() {
    if (timer) window.clearInterval(timer);
    timer = null;
  }

  var prevBtn = root.querySelector('[data-lc-hero-prev]');
  var nextBtn = root.querySelector('[data-lc-hero-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      goTo(i);
      start();
    });
  });

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);

  start();
})();
